export const LicenseStylesColums = {
  buttonContainer: {
    display: "flex",
    alignItems: "left",
    gap: 0.5,
    justifyContent: "left",
    width: "100%",
  },
};
